import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { ViToastService } from '@vi-iot/ui';

@Injectable({
  providedIn: 'root',
})
export class ActionMessagesService {
  constructor(
    private router: Router,
    private translate: TranslateService,
    private toast: ViToastService
  ) {}

  onBmuSerialSuccess(): void {
    const data = {
      actions: [],
      message: this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.MODAL.SET_BMU_SERIAL.SUCCESS_SNACKBAR.MESSAGE'
      ),
    };
    this.toast.info(data);
  }

  onBmuSerialError(): void {
    const data = {
      actions: [],
      message: this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.SYSTEM_DETAILS.MODAL.SET_BMU_SERIAL.FAILURE_SNACKBAR.MESSAGE'
      ),
    };
    this.toast.error(data);
  }

  onSerialSuccess(installationId: number): void {
    const data = {
      actions: [],
      message: this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SET_SERIAL.SUCCESS_SNACKBAR.MESSAGE'
      ),
    };

    if (this.router.url !== `/installations/${installationId}`) {
      data.actions.push({
        id: 'navigate-btn',
        name: this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SET_SERIAL.SUCCESS_SNACKBAR.BUTTON'
        ),
        navigate: `/installations/${installationId}`,
      });
    }

    this.toast.info(data);
  }

  onSerialError(installationId: number): void {
    const data = {
      actions: [],
      message: this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SET_SERIAL.FAILURE_SNACKBAR.MESSAGE'
      ),
    };

    if (this.router.url !== `/installations/${installationId}`) {
      data.actions.push({
        id: 'navigate-btn',
        name: this.translate.instant(
          '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.SET_SERIAL.FAILURE_SNACKBAR.BUTTON'
        ),
        navigate: `/installations/${installationId}`,
      });
    }

    this.toast.error(data);
  }

  onStopMonitoringSuccess(ownerName: string): void {
    const messageTranslationKey = ownerName
      ? '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.UNFOLLOW_INSTALLATION.SUCCESS_SNACKBAR'
      : '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.UNFOLLOW_INSTALLATION.WITHOUT_OWNER.SUCCESS_SNACKBAR';

    this.toast.info({
      message: this.translate
        .instant(messageTranslationKey)
        .replace(/{{ownerName}}/gi, `${ownerName}`),
    });
  }

  onStopMonitoringError(): void {
    this.toast.error({
      message: this.translate.instant(
        '+INSTALLATIONS.INSTALLATION.DEVICE_CARD.UNFOLLOW_INSTALLATION.ERROR_SNACKBAR'
      ),
    });
  }
}
